<template>
  <div class="app-channel-accept">
    <slot name="txtBefore"></slot>

    <div class="input-consent ad-channel">
      <div class="custom-checkbox">
        <input type="checkbox"
               :id="`input-consent-${_uid}`"
               v-model="selected"
               class="consent-checkbox">
        <label :for="`input-consent-${_uid}`"></label>

      </div>
      <label :for="`input-consent-${_uid}`" class="consent-label">
        <p>
          <span class="consent-label"><slot name="lblChannel">{{channel.adChannelType}}</slot></span>
          <span class="consent-label-change">
            <slot name="lblChange">Letzte Änderung:</slot> {{dateFormatter(channel.changeDate) }}
          </span>
        </p>
      </label>
    </div>

    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import preFilledInput from '../../../../mixins/preFilledInput'

export default {
  name: 'ChannelAccept',
  mixins: [
    preFilledInput('selected', 'previousValue', 'select')
  ],
  computed: {
    previousValue: function () {
      return this.channel.selected
    }
  },
  methods: {
    dateFormatter (date) {
      return this.$config.calendar.formatter.dateFormatter.format(new Date(date))
    }
  },
  props: {
    channel: {
      type: Object,
      required: true
    }
  }
}
</script>
